
import { Tenant } from 'apprise-core/tenant';
import { User } from 'apprise-core/user';
import { createProvider, createReadonlyProvider } from 'apprise-frontend-core/state/factory';
import { createToggleProvider } from 'apprise-frontend-core/toggle/context';
import { createFormExcludes } from 'apprise-frontend-core/utils/formexcludes';

// tenants
// ---------------------------------------------------------------------------------------------------------

export const [TenantClientCache, useTenantClientCache ] = createProvider({

    all: [] as Tenant[],
    allRefs: [] as Tenant[]
})



// clone
// ---------------------------------------------------------------------------------------------------------

export const [TenantCloneProvider, useTenantClone] = createProvider({

    clone: undefined! as Tenant

})


// toggles
// ---------------------------------------------------------------------------------------------------------

export type TenantToggles = 'tenant-download'

export const [TenantToggleProvider, useTenantToggles] = createToggleProvider<TenantToggles>()


// excludes
// ---------------------------------------------------------------------------------------------------------

export type TenantExcludes = 'active' | 'language' | 'note'

export const [TenantExcludesProvider, useTenantExcludes] = createFormExcludes<TenantExcludes>()  // so far no other excludes.


// excludes
// ---------------------------------------------------------------------------------------------------------

export type TenantConfig = {

    focalPointFilter: (_:User) => boolean
}

export const [TenantConfigProvider, useTenantConfig] = createReadonlyProvider<TenantConfig>({

    focalPointFilter: () => true

})  // so far no other excludes.